
































































































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { RightArrowOutline12 } from '@hb/coffee-icons';
import { ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { RouterV2Enum } from '@/router/router-names';
import router from '@/router';
import { TP_HOME_GUIDE_CREDIT_CLICK, TP_HOME_GUIDE_APPLY_CLICK, TP_HOME_KNOW_US_CLICK } from '@/pages/home/tianqi';
import store from '@/store';
import { PageThemeTypeEnum } from '@/enums/pageThemeType';
import { GeneralConfig } from '../../config/types';

export default defineComponent({
  name: 'NewcomerGuide',
  components: {
    RightArrowOutline12,
  },
  props: {
    config: {
      type: Object as PropType<GeneralConfig>,
      required: false,
    },
  },
  setup(props) {
    const knowUsTitle = computed(() => `认识${props.config?.productName || '哈啰臻有钱'}`);
    /** 如何授信 */
    const onCreditClick = () => {
      ubtSetupPageButton(TP_HOME_GUIDE_CREDIT_CLICK);
      router.app.$router.push({
        path: RouterV2Enum.usingGuid,
        query: {
          index: '0',
        },
      });
    };
    /** 如何提现 */
    const onWidthrawClick = () => {
      ubtSetupPageButton(TP_HOME_GUIDE_APPLY_CLICK);
      router.app.$router.push({
        path: RouterV2Enum.usingGuid,
        query: {
          index: '1',
        },
      });
    };
    /** 了解我们 */
    const onKnowUsClick = () => {
      ubtSetupPageButton(TP_HOME_KNOW_US_CLICK);
      router.app.$router.push({
        path: RouterV2Enum.aboutUs,
      });
    };

    const showRateExp = computed(
      () => store.state.homeStore.showRateTextExp
      && store.state.base.pageThemeType === PageThemeTypeEnum.BLUE_THEME,
    );
    /** 利率展示文案 */
    const showRateText = computed(() => {
      if (showRateExp.value) {
        const { rateFloor, rateCeil } = store.state.base.businessInfoExtra?.creditInfo;
        return `综合年化利率(单利)${rateFloor}%-${rateCeil}%`;
      }

      return '';
    });
    return {
      knowUsTitle,
      showRateText,

      onCreditClick,
      onWidthrawClick,
      onKnowUsClick,
    };
  },
});
